import React from "react";
import {
  Modal,
  ModalDialog,
  DialogTitle,
  DialogContent,
  Stack,
  Button,
  Typography,
} from "@mui/joy";

interface NameConflictModalProps {
  open: boolean;
  originalName: string;
  resolvedName: string;
  onProceed: () => void;
  onGoBack: () => void;
}

const NameConflictModal: React.FC<NameConflictModalProps> = ({
  open,
  originalName,
  resolvedName,
  onProceed,
  onGoBack,
}) => {
  return (
    <Modal open={open} onClose={onGoBack}>
      <ModalDialog className="modal" sx={{ maxWidth: 500 }}>
        <DialogTitle>Name Conflict</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 2 }}>
            <Typography>
              The name <strong>'{originalName}'</strong> is already taken. It
              will be saved as <strong>'{resolvedName}'</strong>.
            </Typography>
          </Stack>
        </DialogContent>

        <Stack
          direction="row"
          spacing={1}
          sx={{ mt: 2, justifyContent: "flex-end" }}
        >
          <Button variant="outlined" color="neutral" onClick={onGoBack}>
            Go Back
          </Button>
          <Button variant="solid" color="primary" onClick={onProceed}>
            Proceed
          </Button>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};

export default NameConflictModal;
